export const scrollSpy = () => {
    const articleContent = document.querySelector(".article-text-with-toc");

    // Scroll spy
    if (articleContent) {
        const articleHeadings = articleContent.querySelectorAll(".article-text-with-toc .section");

        if ("IntersectionObserver" in window) {
            let options = {
                rootMargin: "0px",
                threshold: 0.5
            };

            let observer = new IntersectionObserver(onChange, options);

            articleHeadings.forEach(heading => observer.observe(heading));

            function onChange(entries, observer) {
                entries.forEach(entry => {
                    if (entry.target.id && entry.target.id !== "") {
                        //In viewport?
                        if (entry.intersectionRatio > 0.5) {
                            if (document.querySelector('.article-toc [href="#' + entry.target.id + '"]')) {
                                document
                                    .querySelector('.article-toc [href="#' + entry.target.id + '"]')
                                    .classList.add("active");
                            }
                        } else {
                            if (document.querySelector('.article-toc [href="#' + entry.target.id + '"]')) {
                                document
                                    .querySelector('.article-toc [href="#' + entry.target.id + '"]')
                                    .classList.remove("active");
                            }
                        }
                    }
                });
            }
        }
    }
};
